import { render, staticRenderFns } from "./activosInfo.vue?vue&type=template&id=3207b42a&"
import script from "./activosInfo.vue?vue&type=script&lang=js&"
export * from "./activosInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports